import React from "react";
import { SectionItem } from "../sections/SectionItem";

export const RightPart = ({ sections }) => {
  return (
    <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12">
      {sections.map((section) => (
        <div className="col-12 section-item" key={section.id}>
          <SectionItem section={section} sections={sections} />
        </div>
      ))}
    </div>
  );
};
